import React, {Fragment, useContext, useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import {
    Button,
} from "@material-ui/core";
import ProgressBar from "../../../../customer/ProductsCustomer/ProgressBar";
import {Formik, Form} from "formik";
import Loading from "../../../../Loading";

import ValidationSchema from "./FormModel/validationSchema";
import CarFormModel from "./FormModel/formModel";
import FormInitialValues from "./FormModel/formInitialValues";

import useStyles from "./styles";

import TitularForm from "./Forms/TitularForm";
import CoberturaForm from "./Forms/CoberturaForm";
import CoberturaFormMobile from './FormsMobile/CoberturaFormMobile'
import {useMediaQuery} from "react-responsive";
import white_others_icon from "../../../../../assets/images/white_others_icon.png";
import Axios from "axios";

import AffinityContext from "../../../../../context/AffinityContext";
import close_x from "../../../../../assets/images/close_x.png";
import {formatPhoneNumberIntl} from "react-phone-number-input";

const steps = ["Cliente", "Producto"];
const {formId, formField} = CarFormModel;


function _renderStepContent(step, localidades, productOtros, isMobile) {
    switch (step) {
        case 0:
            return (<TitularForm
                        formField={formField}
                        localidadesData={localidades}
                    />
            );
        case 1:
            return (isMobile ? <CoberturaFormMobile formField={formField} productOtros={productOtros}/> :
                <CoberturaForm formField={formField} productOtros={productOtros}/>);
        default:
            return <div>Not Found</div>;
    }
}

export default function CheckoutCustomerCotizar(props) {

    const {
        localidades,
        affinityId,
        affinityInterCode,
        productOtros
    } = useContext(AffinityContext);

    let modifiedFormInitialValues = {
        ...FormInitialValues
    }

    const classes = useStyles();
    const [activeStep, setActiveStep] = useState(0);
    const isMobileDevice = useMediaQuery({
        query: "(max-device-width: 480px)",
    });

    const history = useHistory();
    const currentValidationSchema = ValidationSchema[activeStep];
    const isLastStep = activeStep === steps.length - 1;

    const [valuesModal, setValuesModal] = useState([]);
    const [actionsModal, setActionsModal] = useState(null);
    const [localidadesMap, setLocalidadesMap] = useState(null)
    const {confirmationModalOpen, setConfirmationModalOpen, isMobile, scrollIntoView} = props;

    async function _submitForm(values, actions) {
        let url = process.env.REACT_APP_BACK_SERVER + '/precotizar/otros'

        values.idAfinidad = affinityId
        values.Tipo = "OTROS"

        values.codArea = formatPhoneNumberIntl(values.phone).split(' ')[1]
        values.phone = `${formatPhoneNumberIntl(values.phone).split(' ')[2]}${formatPhoneNumberIntl(values.phone).split(' ')[3]}`

        const jsonData = {
            "idAfinidad": affinityId,
            "comentario": values.comentario,
            "CodLocalidad": values.codLocalidad,
            "DNI": values.dni,
            "Apellido": values.lastName,
            "Nombre": values.name,
            "Email": values.email,
            "CodArea": values.codArea,
            "Telefono": values.phone,
            "Tipo": values.tipoSeguro
        }

        Axios.post(url, jsonData).then((result) => {
            console.log(result.status)
            actions.setSubmitting(false);
        }).catch((error) =>
            console.log(error));

        setActiveStep(activeStep + 1);
    }

    function _handleSubmit(values, actions) {
        scrollIntoView()
        if (isLastStep) {
            actions.setTouched({});
            actions.setSubmitting(false);
            setValuesModal(values);
            setActionsModal(actions)
            setConfirmationModalOpen(true);
        } else {
            setActiveStep(activeStep + 1);
            actions.setTouched({});
            actions.setSubmitting(false);
        }
    }

    function _handleBack() {
        setActiveStep(activeStep - 1);
    }

    const handleClose = () => {
        setConfirmationModalOpen(false);
    }

    useEffect(() => {
        let options = localidades.map(d => ({
            "value": d.CodPostal.toString() + ',' + d.CodSancorLocalidad.toString(),
            "label": '(' + d.CodPostal.toString() + ') ' + d.Localidad
        }));
        setLocalidadesMap(options);

    }, [localidades])

    return (
        <React.Fragment>
            {localidadesMap ?
                <>
                    <div
                        className={classes.iconCircle}
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                            marginTop: "-50px",
                            height: "50px"
                        }}
                    >
                        <img src={white_others_icon} alt="white_car_icon" style={{width: "36px", height: "auto"}}/>
                    </div>

                    <div style={{margin: "16px 0"}}>
                        <ProgressBar activeStep={activeStep} stepTitles={steps}/>
                    </div>

                    <Fragment>
                        <Formik
                            initialValues={modifiedFormInitialValues}
                            validationSchema={currentValidationSchema}
                            validateOnBlur={false}
                            onSubmit={_handleSubmit}
                        >
                            {({isSubmitting}) => (
                                <Form id={formId}>
                                    {_renderStepContent(activeStep, localidadesMap, productOtros, isMobileDevice)}
                                    <div className={classes.buttons}>
                                        {activeStep !== 0 && (
                                            <div className={classes.buttons}>
                                                <Button
                                                    onClick={_handleBack}
                                                    className={classes.backButton}
                                                    variant="contained"
                                                >
                                                    Atras
                                                </Button>
                                            </div>
                                        )}
                                        <div className={classes.buttons}>
                                            <Button
                                                disabled={isSubmitting}
                                                type="submit"
                                                variant="contained"
                                                className={classes.buttonContained}
                                            >
                                                {isLastStep ? "Solicitar cotización" : "Siguiente"}
                                            </Button>
                                        </div>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </Fragment>
                </>
                :
                <Loading/>}

            {confirmationModalOpen &&
            <div className={isMobile ? classes.modalMainMobile : classes.modalMainDesktop}>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end"}}>
                    <img
                        style={{
                            marginTop: "5px",
                            marginRight: "10px",
                        }}
                        onClick={handleClose}
                        src={close_x}
                        width={"12px"}
                        height={"12px"}
                    />
                </div>
                <div className={classes.modalColumn}>
                    <p className={classes.modalTitle} style={{marginBottom: "16px", marginTop: "16px"}}> ¿Confirma su
                        información de contacto? </p>
                    <div>
                        <p className={classes.modalSubtitle}> Email </p>
                        <p className={classes.modalText2}> {valuesModal.email} </p>
                        <p className={classes.modalSubtitle}> Celular </p>
                        <p className={classes.modalText2}
                           style={{marginBottom: "24px"}}> {(valuesModal.phone).toString()} </p>
                    </div>
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingBottom: "16px"
                    }}>
                        <button className={classes.modalButtonModify} onClick={() => {
                            setActiveStep(0);
                            setConfirmationModalOpen(!confirmationModalOpen)
                        }}>
                            Modificar
                        </button>
                        <button className={classes.modalButtonConfirm} onClick={() => {
                            setConfirmationModalOpen(!confirmationModalOpen)
                            _submitForm(valuesModal, actionsModal).then(() => history.push(`/a/${affinityInterCode}/${affinityId}/end`));
                        }}>
                            Confirmar
                        </button>
                    </div>
                </div>

            </div>}
        </React.Fragment>
    );
}
